module.exports = [
	{
		"entityType": "networks",
		"name": "Networks",
		"entity_id": "networks",
		"children": [
			{
				"entityType": "directConnects",
				"name": "Direct Connects",
				"entity_id": "directConnects",
				"hasChildren": true
			},
			{
				"entityType": "orgVdcNetworks",
				"name": "Organization Networks",
				"entity_id": "orgVdcNetworks",
				"hasChildren": true
			}
		]
	},
	{
		"entityType": "gateways",
		"name": "Gateways",
		"entity_id": "gateways",
		"hasChildren": true
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/network-tree-nodes/root-nodes.json
// module id = U16/
// module chunks = 0